import type { ChatMessage } from "../stores";
import { getToolDisplayInfo } from "../toolConfig";
import { PulseDot } from "../widgets";

interface ToolActivityThinkingBlockProps {
  toolCalls: ChatMessage[];
}

const ToolActivityThinkingBlock = ({ toolCalls }: ToolActivityThinkingBlockProps) => (
  <div className="my-0.5 flex max-w-full flex-col gap-1.5">
    <div className="flex items-center gap-2">
      <PulseDot variant="blue" isAnimated className="m-0.5" />
      <span className="text-xs font-medium text-gray-500">Thinking...</span>
    </div>
    <div className="ml-5 flex min-w-0 flex-col gap-1">
      {toolCalls.map((message, index) => {
        if (!message.toolCall) {
          return null;
        }
        const displayInfo = getToolDisplayInfo(message.toolCall);
        return (
          <div
            key={message.toolCall.id ?? `${message.toolCall.name}-${index}`}
            className="truncate text-xs leading-5 text-gray-500"
          >
            {displayInfo.displayName}
          </div>
        );
      })}
    </div>
  </div>
);

export default ToolActivityThinkingBlock;
